import React from 'react';
import Transition from 'react-transition-group/Transition';
import PropTypes from 'prop-types';
import { glueEaseInOut } from './../variables';

export const Fade = ({ children, style, className, timeout = 0, ...props }) => {
  const defaultStyle = {
    ...style,
    transitionProperty: 'opacity',
    transitionDuration: '800ms',
    transitionTimingFunction: glueEaseInOut,
    opactity: 0,
  };
  const transitionStyles = {
    exited: { opacity: 0 },
    exiting: { opacity: 1 },
    entering: { opacity: 0 },
    entered: { opacity: 1 },
  };

  return (
    <Transition timeout={timeout} {...props}>
      {state => (
        <div
          className={className}
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  );
};

Fade.propTypes = {
  timeout: PropTypes.number,
  style: PropTypes.shape({}),
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
